import script from "./TaskDueToDateLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskDueToDateLabel.vue?vue&type=script&setup=true&lang=js"

import "./TaskDueToDateLabel.vue?vue&type=style&index=0&id=7f3e436a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f3e436a"]])

export default __exports__